/** 관리자 로고·이미지 설정 localStorage 키 (MainLayout, AdminLogin, OtpPage에서 사용) */
export const ADMIN_LOGIN_LOGO_KEY = 'admin_login_logo';
export const ADMIN_LOGIN_BG_KEY = 'admin_login_bg';
export const ADMIN_HEADER_LOGO_KEY = 'admin_header_logo';

export const DEFAULT_ADMIN_LOGIN_LOGO = '/img/logo_2.png';
export const DEFAULT_ADMIN_LOGIN_BG = '/img/login_bg_img.png';

/** 기본에는 이미지 없음. 관리자가 업로드·설정한 경우에만 표시 */
export function getAdminLoginLogo() {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(ADMIN_LOGIN_LOGO_KEY) || '';
}

export function getAdminLoginBg() {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(ADMIN_LOGIN_BG_KEY) || '';
}

/** 업로드 성공 시 설정 → 이미지 URL에 ?t= 붙여 캐시 무효화 */
export const SITE_ASSETS_VERSION_KEY = 'site_assets_version';

function appendCacheBust(url) {
  if (typeof window === 'undefined' || !url) return url;
  const v = localStorage.getItem(SITE_ASSETS_VERSION_KEY);
  return v ? `${url}${url.includes('?') ? '&' : '?'}t=${v}` : url;
}

/** 로그인 배경 이미지 고정 경로: REACT_APP_API/public/site-assets/login-background.png */
export function getLoginBackgroundAssetUrl() {
  const base = (typeof window !== 'undefined' ? process.env.REACT_APP_API : '') || '';
  const path = '/public/site-assets/login-background.png';
  const url = base ? `${base.replace(/\/$/, '')}${path}` : path;
  return appendCacheBust(url);
}

/** 로그인 로고 이미지 고정 경로: REACT_APP_API/public/site-assets/login-logo.png */
export function getLoginLogoAssetUrl() {
  const base = (typeof window !== 'undefined' ? process.env.REACT_APP_API : '') || '';
  const path = '/public/site-assets/login-logo.png';
  const url = base ? `${base.replace(/\/$/, '')}${path}` : path;
  return appendCacheBust(url);
}

/** 헤더 로고 이미지 고정 경로: REACT_APP_API/public/site-assets/header-logo.png */
export function getHeaderLogoAssetUrl() {
  const base = (typeof window !== 'undefined' ? process.env.REACT_APP_API : '') || '';
  const path = '/public/site-assets/header-logo.png';
  const url = base ? `${base.replace(/\/$/, '')}${path}` : path;
  return appendCacheBust(url);
}
